import React from 'react';
import PropTypes from 'prop-types';
import { B as Box } from './Box-17ae6268.js';
import _extends from '@babel/runtime/helpers/extends';
import { p as props } from './componentEl-c8b73b10.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import IconWsj from './IconWsj.js';
import IconMarketwatch from './IconMarketwatch.js';
import IconBarrons from './IconBarrons.js';
import IconFnlondon from './IconFnlondon.js';
import IconPen from './IconPen.js';
import IconMansionglobal from './IconMansionglobal.js';
import IconMansionglobalBoutique from './IconMansionglobalBoutique.js';
import IconDowjones from './IconDowjones.js';
import IconThetimes from './IconThetimes.js';
import IconWsjopinion from './IconWsjopinion.js';
import IconWsjChina from './IconWsjChina.js';
import IconWsjJapan from './IconWsjJapan.js';
import IconIbd from './IconIbd.js';
import IconWsjcommerce from './IconWsjcommerce.js';
import { I as IconBuyside } from './IconBuyside-d16c7e03.js';
import IconPenta from './IconPenta.js';
import IconYdj from './IconYdj.js';
import IconDjRiskJournal from './IconDjRiskJournal.js';
import { L as LogoFallback } from './LogoFallback-03bda8ca.js';

/**
 * The configs for the various Dow Jones logos
 * TODO: need to find a better system, so this is importanble
 */
var defaultLogos = {
  wsj: {
    name: 'The Wall Street Journal',
    value: 'wsj',
    image: IconWsj,
    background: '#222'
  },
  marketwatch: {
    name: 'MarketWatch',
    value: 'marketwatch',
    image: IconMarketwatch,
    background: '#2e2e2f'
  },
  barrons: {
    name: 'Barrons',
    value: 'barrons',
    image: IconBarrons,
    background: '#1a2737'
  },
  djriskjournal: {
    name: 'Dow Jones Risk Journal',
    value: 'rn',
    image: IconDjRiskJournal,
    background: '#fff',
    color: '#02A3D5'
  },
  fnlondon: {
    name: 'Financial News',
    value: 'fnlondon',
    image: IconFnlondon,
    background: '#f37056'
  },
  pen: {
    name: 'Private Equity News',
    value: 'pen',
    image: IconPen,
    background: '#1f3771'
  },
  mansionglobal: {
    name: 'Mansion Global',
    value: 'mansionglobal',
    image: IconMansionglobal,
    background: '#000'
  },
  mgboutique: {
    name: 'Mansion Global Boutique',
    value: 'mgboutique',
    image: IconMansionglobalBoutique,
    background: '#000'
  },
  dowjones: {
    name: 'Dow Jones',
    value: 'dowjones',
    image: IconDowjones,
    background: '#0c2a31',
    color: '#02a3d5'
  },
  thetimes: {
    name: 'The Times',
    value: 'thetimes',
    image: IconThetimes,
    background: '#000'
  },
  wsjopinion: {
    name: 'WSJ Opinion',
    value: 'wsjopinion',
    image: IconWsjopinion,
    background: '#fff',
    color: '#000'
  },
  cwsj: {
    name: 'WSJ China',
    value: 'cwsj',
    image: IconWsjChina,
    background: '#fff',
    color: '#000'
  },
  jwsj: {
    name: 'WSJ Japan',
    value: 'jwsj',
    image: IconWsjJapan,
    background: '#fff',
    color: '#000'
  },
  ibd: {
    name: 'Investors Business Daily',
    value: 'ibd',
    image: IconIbd,
    background: '#0065AA',
    color: '#fff'
  },
  wsjcommerce: {
    name: 'Buy Side',
    value: 'wsjcommerce',
    image: IconWsjcommerce,
    background: '#336666'
  },
  buyside: {
    name: 'Buy Side',
    value: 'buyside',
    image: IconBuyside,
    background: '#336666'
  },
  penta: {
    name: 'Penta',
    value: 'penta',
    image: IconPenta,
    background: '#fff',
    color: '#000'
  },
  ydj: {
    name: 'Dow Jones Yomiuri Pro',
    value: 'ydj',
    image: IconYdj,
    background: '#fff',
    color: '#000'
  }
};

/**
BrandSelect Item component
*/
function BrandSelectItem({
  componentEl: Component,
  className,
  children,
  type,
  productImage,
  productName,
  productBackground,
  productColor,
  style = {},
  ...otherProps
}) {
  let cssClasses = ['st_brandselect__item'];
  cssClasses = addClassNames(`st_brandselect__item--${type}`, cssClasses);
  cssClasses = addClassNames(className, cssClasses);
  const styleProps = {
    ...style
  };
  let ImageElement = productImage;
  let name = productName || type;
  let background = productBackground;
  let color = productColor;

  // temporary while we support type
  // we have product name, background, etc predefined in a separate object
  if (type && defaultLogos[type]) {
    ({
      image: ImageElement,
      name,
      background,
      color
    } = defaultLogos[type]);
  } else if (type) {
    background = '#fff';
    color = '#000';
  }

  // set background and color of svg via inline CSS
  if (background) {
    styleProps.background = background;
  }
  if (color) {
    styleProps.color = color;
  }
  let content = children;
  if (ImageElement) {
    content = /*#__PURE__*/React.createElement(ImageElement, {
      size: "none",
      className: "st_brandselect__logo"
    });
  } else if (type && !ImageElement) {
    content = /*#__PURE__*/React.createElement(LogoFallback, {
      maxlen: 6,
      className: "st_brandselect__logo",
      text: productName || type
    });
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' '),
    "aria-label": name,
    style: styleProps
  }, otherProps), content);
}
BrandSelectItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /**
   * React element with the SVG for the logo
   * Use `<SvgIcon>` to pass your own logo SVG
   */
  productImage: PropTypes.any,
  /** name of product, to be used for a11y, e.g. `Dow Jones`, `MarketWatch`, etc */
  productName: PropTypes.string,
  /** CSS background property override, e.g. `#ff0000` */
  productBackground: PropTypes.string,
  /** CSS color property override for SVG paths, if needed */
  productColor: PropTypes.string,
  /** name of product, if it already exists */
  type: PropTypes.oneOfType([PropTypes.oneOf(['wsj', 'marketwatch', 'barrons', 'fnlondon', 'pen', 'mansionglobal', 'dowjones', 'thetimes', 'wsjopinion', 'ibd', 'wsjcommerce', 'buyside', 'cwsj', 'jwsj', 'penta', 'rn']), PropTypes.string])
};
BrandSelectItem.defaultProps = {
  componentEl: 'button',
  className: null,
  type: null,
  productName: null,
  productImage: null,
  productBackground: null,
  productColor: null
};
BrandSelectItem.displayName = 'BrandSelect.Item';

/**
BrandSelect component
*/
function BrandSelect({
  children,
  className,
  title
}) {
  let cssClasses = ['st_brandselect'];
  cssClasses = addClassNames(className, cssClasses);
  const count = React.Children.count(children);
  let columns = 0;
  if (count === 0) return null;
  if (count <= 4) {
    columns = count;
  } else if (count <= 6) {
    columns = 3;
  } else {
    columns = 4;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cssClasses.join(' ')
  }, /*#__PURE__*/React.createElement(Box, {
    className: "st_brandselect__box"
  }, /*#__PURE__*/React.createElement(Box.Title, null, title), /*#__PURE__*/React.createElement(Box.Content, {
    padding: {
      vertical: 'md',
      horizontal: 'mlg'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: `st_brandselect__grid st_brandselect__grid--${columns}`
  }, children))));
}
BrandSelect.propTypes = {
  /** title for Brand Select box */
  title: PropTypes.string,
  /** extra CSS classes, if any */
  className: classNamePropTypes
};
BrandSelect.defaultProps = {
  title: 'Select Brand',
  className: null
};
BrandSelect.Item = BrandSelectItem;

export { BrandSelect as B };
